export default __webpack_public_path__ + "static/media/pickImage.8e9a9d9a.svg";